import dateFormat from "./dateFormat";

export default function getDuration(startData, endData) {
  if(typeof startData=="undefined"|| typeof endData=="undefined")return;
  const startTimestamp=dateFormat(startData).timestamp
  const endTimestamp=dateFormat(endData).timestamp
  const startDate = new Date(startTimestamp);
  const endDate = new Date(endTimestamp);
  
  const timeDifferenceInMillis = endDate - startDate;
  const seconds = Math.floor(timeDifferenceInMillis / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  
  return `${hours % 24}H ${minutes % 60}M ${seconds % 60}S`;
}
  